var _path, _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReimbursementsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 60,
    viewBox: "0 0 44 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8711 49.4088C31.9752 49.4088 37.7343 43.5487 37.7343 36.3199C37.7343 29.0911 31.9752 23.231 24.8711 23.231C17.7669 23.231 12.0078 29.0911 12.0078 36.3199C12.0078 43.5487 17.7669 49.4088 24.8711 49.4088Z",
    fill: "#0460FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2328_4554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8714 52.0605C33.4147 52.0605 40.3404 45.0132 40.3404 36.32C40.3404 27.6268 33.4147 20.5796 24.8714 20.5796C16.3281 20.5796 9.40234 27.6268 9.40234 36.32C9.40234 45.0132 16.3281 52.0605 24.8714 52.0605Z",
    fill: "url(#paint0_linear_2328_4554)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2328_4554)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_2328_4554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8733 47.5746C30.982 47.5746 35.934 42.5356 35.934 36.3198C35.934 30.1039 30.982 25.0649 24.8733 25.0649C18.7646 25.0649 13.8125 30.1039 13.8125 36.3198C13.8125 42.5356 18.7646 47.5746 24.8733 47.5746Z",
    fill: "url(#paint1_linear_2328_4554)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2328_4554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2409 39.53C26.2409 39.0857 26.1361 38.7421 25.9207 38.4874C25.7053 38.2327 25.3269 37.9958 24.7913 37.7707C24.2499 37.5456 23.7551 37.3205 23.2952 37.0894C22.8353 36.8584 22.4453 36.5919 22.1135 36.2898C21.7816 35.9877 21.5313 35.6382 21.3508 35.2413C21.1762 34.8444 21.0889 34.3587 21.0889 33.7959C21.0889 32.8482 21.4032 32.0662 22.032 31.4561C22.6607 30.846 23.499 30.4846 24.541 30.3839V28.6128H25.8566V30.4195C26.8638 30.5735 27.6555 30.9941 28.2318 31.6871C28.8081 32.3802 29.0934 33.2569 29.0934 34.3231H26.2991C26.2991 33.7426 26.1885 33.2924 25.9673 32.9785C25.746 32.6645 25.4317 32.5105 25.0242 32.5105C24.6633 32.5105 24.378 32.629 24.1801 32.86C23.9821 33.091 23.8774 33.4109 23.8774 33.8196C23.8774 34.2284 23.9938 34.566 24.2266 34.8089C24.4595 35.0517 24.8321 35.2828 25.3385 35.5078C25.8508 35.727 26.334 35.958 26.7881 36.195C27.2422 36.4319 27.6322 36.7044 27.964 37.0065C28.2958 37.3086 28.552 37.664 28.7383 38.0668C28.9246 38.4696 29.0177 38.9554 29.0177 39.5181C29.0177 40.4777 28.7208 41.2597 28.1212 41.8639C27.5216 42.4681 26.7124 42.8235 25.682 42.9242V44.6065H24.3664V42.9064C23.1671 42.7761 22.2473 42.3614 21.6012 41.6506C20.9608 40.9398 20.6406 40.0098 20.6406 38.8488H23.4233C23.4233 39.4885 23.563 39.9742 23.8424 40.306C24.1219 40.6377 24.5177 40.8035 25.03 40.8035C25.4026 40.8035 25.6995 40.691 25.9149 40.46C26.1303 40.2289 26.2409 39.9268 26.2409 39.53Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_2328_4554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2845 23.2319C33.5157 18.0377 27.0345 16.2494 22.2956 15.6447C19.954 15.3605 18.0391 15.3605 17.0995 15.3863V20.8958L11.5732 16.4872L4 10.4453L17.1045 0V5.4785C19.2531 5.44232 26.4606 5.77826 31.8192 11.6185C33.0687 12.9623 34.2116 14.6162 35.1665 16.6371C36.0553 18.508 36.7766 20.6839 37.2845 23.2319Z",
    fill: "url(#paint2_linear_2328_4554)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2328_4554",
    x: 5.75167,
    y: 20.5796,
    width: 38.2388,
    height: 38.7823,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.65067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.82534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.55417 0 0 0 0 0.623252 0 0 0 0 0.860433 0 0 0 0.73 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2328_4554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2328_4554",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2328_4554"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2328_4554",
    x: 9.45851,
    y: 21.3808,
    width: 30.8291,
    height: 31.2178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.669845
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.177
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2328_4554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2328_4554",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_2328_4554",
    x: 10.1618,
    y: 25.0649,
    width: 29.4224,
    height: 29.8111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.65067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.82534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.55417 0 0 0 0 0.623252 0 0 0 0 0.860433 0 0 0 0.73 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2328_4554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2328_4554",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2328_4554"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2328_4554",
    x: 19.3009,
    y: 27.9429,
    width: 11.1325,
    height: 18.673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.669845
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.669845
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2328_4554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2328_4554",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_2328_4554",
    x: 0.349325,
    y: 0,
    width: 40.5865,
    height: 30.5333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.65067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.82534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.55417 0 0 0 0 0.623252 0 0 0 0 0.860433 0 0 0 0.73 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2328_4554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2328_4554",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2328_4554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2328_4554",
    x1: 33.7312,
    y1: 21.4064,
    x2: 0.914837,
    y2: 36.3376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2328_4554",
    x1: 31.2083,
    y1: 25.6562,
    x2: 7.74371,
    y2: 36.3323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2328_4554",
    x1: 30.1741,
    y1: 0.61019,
    x2: 0.580418,
    y2: 20.2398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#A3BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3866,
    stopColor: "#82A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#4F71F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReimbursementsIcon);
export default __webpack_public_path__ + "static/media/reimbursementsIcon.31892581a77ca9f87c16505d4d4b83e3.svg";
export { ForwardRef as ReactComponent };